import React from 'react';
import { HiSparkles } from 'react-icons/hi2';

const Logo = ({ w = 60, h = 50 }) => {
    return (
        <div 
            className="flex items-center justify-center cursor-pointer group"
            style={{ height: h, width: w }}
        >
            {/* Creative Icon with U */}
            <div className="relative flex-shrink-0">
                {/* Main square icon with gradient */}
                <div className="relative w-12 h-12 md:w-13 md:h-13 bg-gradient-to-br from-orange-500 via-orange-400 to-yellow-500 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 transform group-hover:scale-110 group-hover:rotate-3 overflow-hidden">
                    {/* Animated background pattern */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-yellow-300/30 via-transparent to-orange-600/30"></div>
                    
                    {/* Shine effect */}
                    <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-transparent"></div>
                    
                    {/* U Letter with shadow */}
                    <span className="text-white text-2xl md:text-3xl font-black relative z-10 drop-shadow-lg">
                        U
                    </span>
                    
                    {/* Corner accent */}
                    <div className="absolute top-1 right-1 w-2 h-2 bg-white/30 rounded-full"></div>
                </div>
                
                {/* Creative decorative elements */}
                <div className="absolute -left-1.5 top-3 w-2.5 h-2.5 bg-gradient-to-br from-orange-400 to-yellow-400 rounded-full shadow-md transform group-hover:scale-125 transition-transform duration-300"></div>
                <div className="absolute -left-1.5 bottom-3 w-2.5 h-2.5 bg-gradient-to-br from-orange-400 to-yellow-400 rounded-full shadow-md transform group-hover:scale-125 transition-transform duration-300"></div>
                <div className="absolute -top-1.5 right-3 w-2.5 h-2.5 bg-gradient-to-br from-orange-400 to-yellow-400 rounded-full shadow-md transform group-hover:scale-125 transition-transform duration-300"></div>
                <div className="absolute -bottom-1.5 right-3 w-2 h-2 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full shadow-sm"></div>
                
                {/* Sparkle effect on hover */}
                <div className="absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <HiSparkles className="text-yellow-400 text-sm animate-pulse" />
                </div>
            </div>
        </div>
    );
}

export default Logo;
